module.exports = __webpack_public_path__ + "static/img/product.8495f53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product.jpg
// module id = 979
// module chunks = 1